import { VabsPaymentDirection } from '@/shared/api/index.ts';
import { cn } from '@/shared/lib';
import { Typography } from '@/shared/ui';

import { formatAmount } from '../lib/helpers.tsx';
import { ITransaction } from '../model/types';
import { TopUpAmount } from './top-up-amount';

interface TransactionAmountProps {
  transaction: ITransaction;
  className?: string;
}

export const TransactionAmount = ({
  transaction,
  className,
}: TransactionAmountProps) => {
  if (transaction.type === VabsPaymentDirection.Incoming) {
    return <TopUpAmount transaction={transaction} className={className} />;
  }

  return (
    <Typography
      className={cn(
        'whitespace-nowrap text-right font-normal leading-5',
        className,
      )}
    >
      {formatAmount(+transaction.sourceTotalAmount, transaction.sourceCurrency, 2, '-')}
    </Typography>
  );
};
